import React from "react";
import PageTransition from "../Components/PageTransition";
import AnimatedHero from "../Components/AnimatedHero";
export default function TermsAndConditions() {
  return (
    <PageTransition className="testimonials-page background">
      <AnimatedHero
        title="Terms & Conditions"
        subtitle="Welcome to Darvik Foundation. By using our website and making a donation,
        you agree to the following terms and conditions."
        className="about-hero"
        overlayColor="rgba(14,77,109,0.15)"
      />
    <div className="container py-5">
     
      <h3>1. Donations</h3>
      <p>
        All donations made to Darvik Foundation are voluntary and used solely
        for charitable purposes. Donors are responsible for providing accurate
        personal and payment information.
      </p>

      <h3>2. Payment</h3>
      <p>
        Payments are processed securely via Razorpay. We do not store your card,
        UPI, or banking details on our servers.
      </p>

      <h3>3. Tax Exemption</h3>
      <p>
        For donors who wish to claim exemption under Section 80G of the Income
        Tax Act, valid PAN and address details must be provided.
      </p>

      <h3>4. Limitation of Liability</h3>
      <p>
        Darvik Foundation is not liable for any issues arising from technical
        errors, payment gateway failures, or incorrect donor details.
      </p>

      <h3>5. Governing Law</h3>
      <p>
        These terms are governed by the laws of India and subject to the
        jurisdiction of courts in Kerala, India.
      </p>
    </div>
    </PageTransition>
  );
}
